import { rivermeadowApi } from './api';

export const migrationAppliances = rivermeadowApi.injectEndpoints({
    endpoints: (builder) => ({
        getSingleCloudAccount: builder.query({
            query: ({ id }) => ({
                url: `/cloudaccounts/${id}`,
                method: 'GET',
                credentials: 'include',
            }),
        }),
        getApplianceById: builder.query({
            query: ({ applianceId }) => ({
                url: `/appliances/${applianceId}`,
                method: 'GET',
                credentials: 'include',
            }),
        }),
        upgradeAppliance: builder.mutation({
            query: ({ applianceId }) => ({
                url: `/appliances/${applianceId}/upgrade`,
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
            }),
        }),
        addTagsToCloudAccount: builder.mutation({
            query: ({ applianceId, tags }) => ({
                url: `/cloudaccounts/${applianceId}`,
                method: 'PUT',
                credentials: 'include',
                body: { tags },
            }),
        }),
    }),
});

export const { useLazyGetApplianceByIdQuery, useAddTagsToCloudAccountMutation, useUpgradeApplianceMutation } =
    migrationAppliances;
